exports = module.exports = require("../../../../../../legacy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about_txtarea {\n  min-height: 70px !important;\n  height: 70px !important;\n}", ""]);

// exports
